export const launchingGameController = {
  initial: 'idle',
  invoke: [{ src: 'watchGameActions' }],
  states: {
    idle: {
      always: [
        {
          target: 'initGameLauncherCommunication',
        },
      ],
    },
    initGameLauncherCommunication: {
      invoke: {
        src: 'initializeGameFrameBridge',
        onDone: {
          target: 'initGameLaunchObserver',
        },
      },
    },
    initGameLaunchObserver: {
      on: {
        LAYOUT_CHANGE_END: {
          target: 'runGameFromDirectLink',
          cond: 'isControllerEnabled_gameLauncher',
        },
        LAYOUT_PAGEID_CHANGE: {
          actions: [
            {
              type: 'setLayoutProperty',
              data: {
                path: 'components.Layout.properties.gameModalOpen',
                value: false,
              },
              meta: {
                selectors: ['$action.data.value'],
              },
            },
          ],
        },
        PROMOTIONS_GAME_OPEN_CLICK: {
          target: 'fetchGameLaunch',
        },
        VIEW_CATEGORY_GAME_TILE_CLICK: [
          {
            target: 'transient',
            actions: 'trackSearchGameClick',
            cond: 'isGameLaunchedFromSearchCategory',
          },
          {
            target: 'transient',
            actions: 'trackGameClick',
          },
        ],
        VIEW_BOTTOM_MENU_GAME_CLICK: {
          target: 'transient',
          actions: 'trackGameClick',
        },
        VIEW_SIDE_MENU_GAME_CLICK: {
          target: 'transient',
          actions: ['trackGameClick'],
        },
        VIEW_GAME_DETAILS_BUTTON_CLICK: [
          {
            target: 'transient',
            actions: 'trackGameClick',
          },
        ],
        VIEW_IDLE_POPUP_PLAY_NOW_CLICK: [
          {
            target: 'transient',
          },
        ],
        VIEW_IDLE_POPUP_GAME_TILE_CLICK: [
          {
            target: 'transient',
          },
        ],
        TREBUCHET_PARTIAL_EVENT_CALLED: {
          actions: 'trackTrebuchetPartialEvent',
        },
        VIEW_SUGGESTED_GAMES_TILE_CLICK: [
          {
            target: 'fetchGameLaunch',
            actions: [
              {
                type: 'save',
                data: {
                  clickedOnSuggestedGame: true,
                },
              },
            ],
          },
        ],
        VIEW_FULL_SCREEN_OVERLAY_CLICK: {
          actions: ['handleFullScreenOverlayClick'],
        },
        GAME_SWITCHED: {
          target: 'fetchGameLaunch',
          actions: [{ type: 'save', data: { isSwitchingGame: true } }],
        },
        GAME_LAUNCH_REQUESTED: {
          target: 'fetchGameLaunch',
          actions: [{ type: 'save', data: { isLaunchedFromLauncher: true } }],
        },
      },
    },
    runGameFromDirectLink: {
      invoke: {
        src: 'runGameFromDirectLink',
        onDone: [
          { target: 'transient', cond: 'shouldRunTheGame' },
          {
            target: 'initGameLaunchObserver',
            actions: [
              {
                type: 'save',
                data: {
                  currentPagePath: '/',
                },
              },
              'updateUrl',
            ],
          },
        ],
      },
    },
    transient: {
      always: [
        {
          //to not lose data from event after logged in event comes
          target: 'setGameToLaunchWhenSessionIsNotResolved',
          cond: 'isSessionNotResolved',
        },
        { target: 'setGameToLaunch' },
      ],
    },
    waitingForSession: {
      on: {
        SESSION_STATE_LOGGED_OUT: 'setGameToLaunch',
        SESSION_STATE_LOGGED_IN: 'waitForLayoutChangeTwo',
      },
    },
    waitForLayoutChangeTwo: {
      on: {
        LAYOUT_CHANGE_END: [
          {
            target: 'trackGameClickedFromLauncher',
          },
        ],
      },
    },
    fetchGameLaunch: {
      invoke: {
        src: 'fetchGameToLaunch',
        onDone: [
          {
            cond: 'isGameFetched',
            target: 'setGameToLaunch',
          },
          {
            target: 'initGameLaunchObserver',
            actions: ['gameFetchFailed'],
          },
        ],
        onError: {
          target: 'initGameLaunchObserver',
          actions: ['layout_openSystemErrorPage'],
        },
      },
    },
    setGameToLaunch: {
      invoke: {
        src: 'setGameToLaunchData',
        onDone: {
          target: 'trackGameClickedFromLauncher',
          actions: {
            type: 'save',
            data: {
              gameToLaunch: '$event.data.gameToLaunch',
            },
            meta: {
              selectors: ['$action.data.gameToLaunch'],
            },
          },
        },
      },
    },
    setGameToLaunchWhenSessionIsNotResolved: {
      invoke: {
        src: 'setGameToLaunchData',
        onDone: {
          target: 'waitingForSession',
          actions: {
            type: 'save',
            data: {
              gameToLaunch: '$event.data.gameToLaunch',
            },
            meta: {
              selectors: ['$action.data.gameToLaunch'],
            },
          },
        },
      },
    },
    trackGameClickedFromLauncher: {
      always: [
        {
          target: 'initLaunchGameFlow',
          actions: [
            'setSuggestedGameUrl',
            'trackGameClickFromLauncher',
            'removeLastPagePath',
          ],
          cond: 'isClickedSuggestedGame',
        },
        {
          target: 'initLaunchGameFlow',
          actions: ['trackGameClickFromLauncher'],
          cond: 'isLaunchedFromLauncher',
        },
        {
          target: 'initLaunchGameFlow',
        },
      ],
    },
    initLaunchGameFlow: {
      always: [
        {
          target: 'launchingGameWithLogin',
          cond: 'isNotAllowedToLaunchGame',
        },
        {
          cond: 'isSwitchingGame',
          target: 'switchGame',
        },
        {
          cond: 'isHybrid888', // do nothing, Hybrid88 will open game
          target: 'initGameLaunchObserver',
        },
        {
          cond: 'isNewWindowStrategy', // do nothing, already handled in component due to popup blockers
          target: 'initGameLaunchObserver',
        },
        {
          actions: 'openGameInCurrentTab',
          cond: 'isModalForMobileNotSupported',
          target: 'launchGame',
        },
        {
          target: 'launchGameInModal',
          cond: 'isLaunchGameInModal',
        },
        {
          target: 'launchGame',
          cond: 'isGameTriggeredByUserInteraction',
        },
        {
          target: 'openGameDetailsPage',
          actions: 'removeGameLaunchController',
        },
      ],
    },
    launchingGameWithLogin: {
      invoke: {
        src: 'launchLogin',
      },
      on: {
        SESSION_STATE_LOGGED_IN: 'waitForLayoutChangeEnd',
        LOGIN_MODAL_STATE_CLOSED: [
          {
            target: 'initGameLaunchObserver',
            actions: ['setBodyScrollable', 'updateUrl'],
            cond: 'isNotAwaitingLogin',
          },
        ],
      },
    },
    waitForLayoutChangeEnd: {
      on: {
        LAYOUT_CHANGE_END: [
          {
            target: 'openGameDetailsPage',
            cond: 'isNewWindowStrategy',
          },
          {
            target: 'launchGameInModal',
            cond: 'isLaunchGameInModal',
          },
          {
            target: 'initGameLaunchObserver',
            cond: 'isGameDetailsPage',
          },
          {
            target: 'openGameDetailsPage',
          },
        ],
      },
    },
    openGameDetailsPage: {
      always: [
        {
          actions: ['removeLastPagePath', 'gameDetails_open'],
          target: 'initGameLaunchObserver',
          cond: 'isOnLaunchPathAlready',
        },
        {
          actions: ['gameDetails_open'],
          target: 'initGameLaunchObserver',
        },
      ],
    },
    switchGame: {
      entry: [
        { type: 'save', data: { isSwitchingGame: false } },
        'updateGameLaunchedTracking',
        'fetchRecentlyPlayedAfterDelay',
      ],
      always: 'initGameLaunchObserver',
    },
    launchGameInModal: {
      entry: [
        'hideMyAccountDropdown',
        'hideBalance',
        'setStatusGameModalForMobile',
        {
          type: 'save',
          data: {
            clickedOnSuggestedGame: false,
          },
        },
        {
          type: 'batchLayoutOperations',
          data: [
            {
              type: 'setLayoutProperty',
              data: {
                path: 'components.GameModal.properties.game',
                value: '$context.gameToLaunch',
              },
              meta: {
                selectors: ['$action.data.value'],
              },
            },
            {
              type: 'setLayoutProperty',
              data: {
                path: 'components.Modal.properties.componentVisible',
                value: false,
              },
              meta: {
                selectors: ['$action.data.value'],
              },
            },
            {
              type: 'setLayoutProperty',
              data: {
                path: 'components.GameDetailsModal.properties.componentVisible',
                value: false,
              },
              meta: {
                selectors: ['$action.data.value'],
              },
            },
            {
              type: 'setLayoutProperty',
              data: {
                path: 'components.GameModal.properties.user',
                value: '$context.user',
              },
              meta: {
                selectors: ['$action.data.value'],
              },
            },
            {
              type: 'setLayoutProperty',
              data: {
                path: 'components.GameModal.properties.isFullScreen',
                value: '$context.isFullScreen',
              },
              meta: {
                selectors: ['$action.data.value'],
              },
            },
            {
              type: 'setLayoutProperty',
              data: {
                path: 'components.Category.properties.visible',
                value: false,
              },
            },
          ],
        },
        'gameModal_open',
        'fetchRecentlyPlayedAfterDelay',
        'categories_reload',
        'rp_rerender',
      ],
      always: 'initGameLaunchObserver',
    },
    launchGame: {
      always: {
        target: 'initGameLaunchObserver',
        actions: [
          'fetchRecentlyPlayedAfterDelay',
          {
            type: 'save',
            data: {
              clickedOnSuggestedGame: false,
            },
          },
          {
            type: 'save',
            data: {
              gameToLaunch: null,
            },
          },
        ],
      },
    },
  },
};
